import { EnumDataType } from '../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';

class PGRow {
  name: string;
  displayName: string;
  dataType: EnumDataType;
  value: any;
  description: string;
  refType: string;
  validation: string;
  isEditable: boolean;
  isBrowsable: boolean;
  customDesigner: string;

  constructor(name: string, displayName: string, dataType: EnumDataType, value: any, isEditable: boolean, description: string, refType: string, customDesigner: string, validation: string) {
    this.name = name;
    this.displayName = displayName;
    this.dataType = dataType;
    this.value = value;
    this.isEditable = isEditable;
    this.description = description;
    this.refType = refType;
    this.customDesigner = customDesigner;
    this.validation = validation;
    this.isBrowsable = true;
  }
}

class PGGroup {
  name: string;
  readonly rows: Array<PGRow>;
  constructor(name: string) {
    this.name = name;
    this.rows = new Array<PGRow>();
  }

  addRow(name: string, displayName: string, dataType: EnumDataType, value: any, isEditable: boolean, description: string, refType = '', customDesigner = '', validation = '') {
    const row = new PGRow(name, displayName, dataType, value, isEditable, description, refType, customDesigner, validation);
    this.rows.push(row);
  }
}

class PGContext {
  designId: string;
  displayName: string;
  readonly groups: Array<PGGroup>;

  constructor(designId: string, displayName: string) {
    this.designId = designId;
    this.displayName = displayName;
    this.groups = new Array<PGGroup>();
  }

  addRow(groupName: string, name: string, displayName: string, dataType: EnumDataType, value: any, isEditable: boolean, description: string, refType = '', customDesigner = '', validation = '') {
    let group: PGGroup;
    const index = this.groups.findIndex(group => group.name === groupName);
    if (index < 0) {
      group = new PGGroup(groupName);
      this.groups.push(group);
      const hisGroupIndex = this.groups.findIndex(group => group.name === '修改历史');
      if (hisGroupIndex > -1) {
        const group0 = this.groups.splice(hisGroupIndex, 1);
        this.groups.push(...group0);
      }
    } else {
      group = this.groups[index];
    }

    group.addRow(name, displayName, dataType, value, isEditable, description, refType, customDesigner, validation);
  }

  /** 根据名称获取行，如果不存在返回null */
  getRow(name: string): PGRow | null {
    if (name !== '') {
      for (let i = 0; i < this.groups.length; i++) {
        const findRow = this.groups[i].rows.find(row => row.name === name);
        if (findRow) {
          return findRow;
        }
      }
    }
    return null;
  }
}

export { PGContext, PGGroup };
